var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ScanGift,{ref:"scanGift",attrs:{"campaignId":_setup.targetActConfig?.mainlandGiftPackModule.campaignId,"spId":_setup.spId,"isHideRule":true,"couponConfig":_setup.couponConfig,"disSource":_setup.disSource},on:{"showState":_setup.handleShowState,"isReady":_setup.handleCompReady}})
}
var staticRenderFns = []

export { render, staticRenderFns }